var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Tree',{attrs:{"data":_vm.areaList,"load-data":_vm.loadData,"expand-node":""},on:{"on-select-change":_vm.onSelectChange,"on-toggle-expand":_vm.onToggleExpand}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-438a040e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/useGas/views/area/mods/tree.vue
// module id = null
// module chunks = 